import type { ReactNode } from "react";
// Sibling inside the ui/ barrel: import directly, never through ./index —
// that would make index -> section -> index a cycle.
import { Card } from "./card";

export function Section({
  title,
  children,
  contentClassName,
}: {
  title: string;
  children: ReactNode;
  contentClassName?: string;
}) {
  return (
    <Card className="p-4.5">
      <h2 className="mb-4 text-xl">{title}</h2>
      {/* Children get their own wrapper so a Disclosure stack sees itself as
          :first-child — the <h2> was occupying that slot and killing
          Disclosure's first:border-t-0, leaving a hairline floating under the
          heading. Callers that need vertical rhythm pass contentClassName. */}
      <div className={contentClassName}>{children}</div>
    </Card>
  );
}
